import { useQuery } from "@tanstack/react-query";

import { ListEligibilityResultsFilterType } from "@/domain/eligibilityResults";

import { EligibilityResultsApi } from "../api/eligibilityResultsApi";

export const EligibilityResultsQueryKeys = {
  all: ["eligibilityResults"] as const,
  list: (filters?: ListEligibilityResultsFilterType) =>
    filters
      ? ([...EligibilityResultsQueryKeys.all, "list", { filters }] as const)
      : ([...EligibilityResultsQueryKeys.all, "list"] as const),
};

export const useListEligibilityResultsQuery = (
  filters: ListEligibilityResultsFilterType,
) => {
  return useQuery({
    queryKey: EligibilityResultsQueryKeys.list(filters),
    queryFn: () => EligibilityResultsApi.listEligibilityResults(filters),
  });
};
